import { Elements } from "@stripe/react-stripe-js";
import { getStripe } from "utils/stripeSecurity";
import FormItem from "components/Form/FormItem";
import DetailSkeleton from "components/Skeleton/DetailSkeleton";
import { paymentStatus } from "components/TripCard/FullTripCard";
import { CheckOutForm, DetailRenderSection1, RenderThingsToKnow } from "components/TripCard/ListingDetail";
import Modal from "components/TripCard/Modal";
import ModalPhotos from "components/TripCard/ModalPhotos";
import { authJsonPost, getUrl } from "functions/BaseAxios";
import currency, { cropAddress } from "functions/common";
import { RootStore } from "functions/redux/store";
import { getBookingDetail } from "functions/redux/transaction/action";
import i18n from "i18n/config";
import moment from "moment";
import { userInfo } from "os";
import React, { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import Loader from "react-loader-spinner";
import Skeleton from "react-loading-skeleton";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router";
import Badge from "shared/Badge/Badge";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import Input from "shared/Input/Input";
import NcImage from "shared/NcImage/NcImage";
import Textarea from "shared/Textarea/Textarea";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Avatar from "shared/Avatar/Avatar";
import NcModal from "shared/NcModal/NcModal";
import { async } from "@firebase/util";
import Geocode from "react-geocode";
import GoogleMapReact from "google-map-react";
import LocationMarker from "components/AnyReactComponent/LocationMarker";

var QRCode = require('qrcode.react');

Geocode.setApiKey(process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "");


const OrderDetail = () => {
    const search = useLocation().search;
    const id = new URLSearchParams(search).get("id");
    const [loading, setLoading] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [adjustmentModal, setAdjustmentModal] = useState(false);
    const [openFormMobile, setOpenFormMobile] = React.useState(true);
    const { t } = useTranslation();
    const { user, transaction } = useSelector((state: RootStore) => state);
    const dispatch = useDispatch();
    const [isOpen, setIsOpen] = React.useState(false);
    const [isCancel, setisCancel] = React.useState(false);
    const handleCloseModal = () => setIsOpen(false);
    const [openFocusIndex, setOpenFocusIndex] = React.useState(0);
    const handleOpenModal = (index: number) => {
        setIsOpen(true);
        setOpenFocusIndex(index);
    };
    const [openStripe, setOpenStripe] = React.useState(false);
    const [priceAdjustment, setPriceAdjustment] = React.useState<any>();
    const [priceAdjustmentText, setPriceAdjustmentText] = React.useState<any>();
    const [stripeOptions, setStripeOptions] = React.useState({ clientSecret: '' });
    const stripePromise = React.useMemo(() => {
        if (!openStripe) return null;
        return getStripe();
    }, [openStripe]);
    const [confimationModal, setConfirmationModal] = React.useState(false);
    const [submitting, setSubmitting] = React.useState(false);
    const [goingToAccept, setGoingToAccept] = React.useState(false);
    const history = useHistory();
    const [paymentMethodModal, setPaymentMethodModal] = React.useState(false);
    const [reasonCancel, setreasonCancel] = React.useState('');
    const [showConfirmationCancel, setShowConfirmationCancel] = React.useState(false);



    React.useEffect(() => {
        if (transaction.bookingDetail == null || transaction.bookingDetail.id != id) {
            dispatch(getBookingDetail(id));
        }
    })

    React.useEffect(() => {
        if (openStripe === false) {
            const declaration = document.getElementsByTagName('html');
            // declaration[0].removeProperty('overflow')
            declaration[0].style.cssText = '';
        }
    }, [openStripe])


    const adjustPrice = async () => {
        try {
            if (priceAdjustment === undefined || priceAdjustmentText === undefined || (priceAdjustment === "" || priceAdjustmentText === "")) {
                toast.error(`${t('all_required')}`);
                return;
            } else {
                setSubmitting(true);
                var data = {
                    id: transaction.bookingDetail.id,
                    adjustmentPrice: priceAdjustment,
                    adjustmentText: priceAdjustmentText
                };
                var checkOut = await authJsonPost(data, 'auth/adjust-price');
                if (checkOut.code === 200) {
                    window.location.reload();
                }
                setSubmitting(false);
                setAdjustmentModal(false);
            }
        } catch (e) {
            setSubmitting(false);
        }
    }

    const cancelTrip = async () => {
        try {
            // console.log(id);
            // console.log(reasonCancel);
            setSubmitting(true);
            setShowConfirmationCancel(false);
            const result = await authJsonPost(
                {
                    id: id,
                    reason: reasonCancel,
                },
                'auth/cancelLation',
            );
            if (result.code === 200) {
                dispatch(getBookingDetail(id));
                toast(`Trips ${t('cancelled')}`);
            }

            setisCancel(false);
            setSubmitting(false);
        } catch (error) {
            setSubmitting(false);
        }
        setSubmitting(false);

    }



    const completeAction = async () => {
        setSubmitting(true);

        try {
            var data = {
                id: transaction.bookingDetail.id,
                reason: "web automatic fill"
            };
            if (goingToAccept) {

                var checkOut = await authJsonPost(data, 'auth/booking-accept');
                if (checkOut.code === 200) {
                    window.location.reload();
                }
            } else {
                var decline = await authJsonPost(data, 'auth/booking-decline')
                if (decline.code === 200) {
                    window.location.reload();
                }
            }
            setSubmitting(false);
            setConfirmationModal(false);
        } catch (e) {
            setSubmitting(false);
        }
    }
    const goWithTransfer = async () => {
        if (transaction.bookingDetail.id !== undefined && transaction.bookingDetail.id != null) {
            setSubmitting(true);
            var id = transaction.bookingDetail.id;
            var checkOut = await authJsonPost(
                { id },
                'auth/manual-transfer',
            );
            setSubmitting(false);
            if (checkOut.code === 200) {
                await dispatch(getBookingDetail(id));
                setPaymentMethodModal(false);

            }
        }
    }
    const renderSidebar = () => {
        return (
            <>
                {/* <Modal
                    children={() => (
                        <div className="flex flex-col w-2/3 p-8 mx-auto rounded-lg drop-shadow bg-white">
                            <span className="ml-2.5 text-neutral-900 dark:text-neutral-200 font-medium">
                                Proses ini tidak bisa dibatalkan, apakah anda yakin untuk meneruskan?
                            </span>
                            <div className="flex flex-row w-full mt-8 space-x-4">
                                <ButtonSecondary onClick={() => setConfirmationModal(false)} className="flex-1 p-2 h-min">No</ButtonSecondary>
                                <ButtonPrimary
                                    onClick={completeAction}
                                    className="flex-1 w-full h-min p-2 ">
                                    {submitting ?
                                        <Loader
                                            type="Circles"
                                            color="white"
                                            height={25}
                                            width={25}
                                        /> : 'Yes'}
                                </ButtonPrimary>
                            </div>
                        </div>
                    )}
                    isOpen={confimationModal}
                /> */}

                <NcModal
                    isOpenProp={confimationModal}
                    renderTrigger={() => { return (<></>); }}
                    contentExtraClass="lg:w-1/2"
                    modalTitle={t('confirmation')}
                    onCloseModal={() => setConfirmationModal(false)}
                    renderContent={() => {
                        return (
                            <div className="">
                                <div className="flex justify-center">
                                    <span>Proses ini tidak bisa dibatalkan, apakah anda yakin untuk <b>{goingToAccept ? 'menerima' : 'menolak'}</b> ?</span>
                                </div>
                                <div className="flex flex-row w-full mt-8 space-x-4">
                                    <ButtonSecondary onClick={() => setConfirmationModal(false)} className="flex-1 p-2 h-min">No</ButtonSecondary>
                                    <ButtonPrimary
                                        onClick={completeAction}
                                        className="flex-1 w-full h-min p-2 ">
                                        {submitting ?
                                            <Loader
                                                type="Circles"
                                                color="white"
                                                height={25}
                                                width={25}
                                            /> : 'Yes'}
                                    </ButtonPrimary>
                                </div>
                            </div>
                        )
                    }}
                />
                {transaction.bookingDetail?.stripePaymentIntent ?
                    <NcModal
                        isOpenProp={openStripe}
                        renderTrigger={() => { return (<></>); }}
                        renderContent={() => {
                            return stripePromise ? (
                                <Elements stripe={stripePromise}
                                    options={stripeOptions}
                                >
                                    <CheckOutForm
                                        data={transaction.bookingDetail}
                                        clientSecret={transaction.bookingDetail.stripePaymentProperty?.paymentIntent} />
                                </Elements>
                            ) : <></>;
                        }}
                        onCloseModal={() => {
                            setOpenStripe(false);
                        }}
                        modalTitle={'Stripe Secure Payment (PCI-DSS)'}
                    />
                    : <></>}

                <div className="listingSection__wrap shadow-xl" style={{ marginTop: '2.5rem' }}>
                    <div className="flex justify-between items-center">
                        <span className="font-semibold">#{transaction.bookingDetail.orderNumber}</span>
                    </div>
                    <div>
                        <div className="flex items-center">
                            <Avatar imgUrl={transaction.bookingDetail.customer.profile.avatar} hasChecked sizeClass="h-10 w-10" radius="rounded-full" />
                            <div className="flex flex-col ml-1">
                                <span className="ml-2.5 text-neutral-900 dark:text-neutral-200 font-regular text-xs">
                                    Customer
                                </span>
                                <span className="ml-2.5 text-neutral-900 dark:text-neutral-200 font-semibold text-md">
                                    {transaction.bookingDetail.customer.profile.displayName}
                                </span>
                            </div>


                        </div>
                    </div>
                    {transaction.bookingDetail.isPaymentSuccess && transaction.bookingDetail.cancellationStatus == null ?
                        user.credential.id === transaction.bookingDetail.customer.id ?
                            <div className="flex flex-col space-y-2">
                                <div className="flex justify-between font-medium">
                                    <span>
                                        Scan when meet the guide
                                    </span>
                                </div>
                                <div className="flex-col items-center">
                                    <QRCode value={transaction.bookingDetail.id} size={250} renderAs="svg" />
                                </div>

                                <div className="flex justify-between font-medium">
                                    <span>
                                        {transaction.bookingDetail.product.isOpenTrip ? `${moment(transaction.bookingDetail.startDate).format('MMMM Do YYYY')} -  ${moment(transaction.bookingDetail.endDate).format('MMMM Do YYYY')}` : `${moment(transaction.bookingDetail.startTripDate).format('MMMM Do YYYY')} -  ${moment(transaction.bookingDetail.endTripDate).format('MMMM Do YYYY')}`}
                                    </span>
                                </div>
                                {/* <div className="flex flex-col justify-between font-medium">
                                <span>Meeting point</span>
                                <span>{transaction.bookingDetail.product.meetingAddress}</span>
                            </div> */}
                            </div>
                            : <></>


                        : <></>}
                    <div className="flex justify-between font-bold">
                        <span>Price Details</span>
                    </div>
                    <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
                    <div className="flex flex-col space-y-2">
                        <div className="flex justify-between font-medium">
                            <span>{i18n.t('small_luggage')}</span>
                            <span>{transaction.bookingDetail.smallLuggage}</span>
                        </div>
                        <div className="flex justify-between font-medium">
                            <span>{i18n.t('big_luggage')}</span>
                            <span>{transaction.bookingDetail.bigLuggage}</span>
                        </div>
                        <div className="flex justify-between font-medium">
                            <span>{i18n.t('under_twelve')}</span>
                            <span>{transaction.bookingDetail.kids.underTwelve}</span>
                        </div>
                        <div className="flex justify-between font-medium !mb-4">
                            <span>{i18n.t('under_two_year')}</span>
                            <span>{transaction.bookingDetail.kids.underTwo}</span>
                        </div>
                        <div className="flex justify-between font-medium">
                            <span>Basic Price</span>
                            <span>{currency(transaction.bookingDetail.price)}</span>
                        </div>

                        <div className="flex justify-between font-medium">
                            {/* <span>Pax</span> */}
                            {/* <span>{transaction.bookingDetail.qty}</span> */}
                            <span>{transaction.bookingDetail.product.isOpenTrip ? 'Pax' : 'Additional slot'}</span>
                            <span>{transaction.bookingDetail.product.isOpenTrip ? transaction.bookingDetail.qty : transaction.bookingDetail.qty + ` x ` + currency(transaction.bookingDetail.additionalSlotPrice)}</span>
                        </div>
                        <div className="flex justify-between font-medium">
                            <span>Price</span>
                            <span>{currency(transaction.bookingDetail.price * transaction.bookingDetail.qty)}</span>
                        </div>



                        {transaction.bookingDetail.additionalServices.length > 0 ?
                            <div className="space-y-2 mt-2">
                                <div className="flex justify-between font-bold">
                                    <span>Additional Services</span>
                                </div>
                                {transaction.bookingDetail.additionalServices.map((item: any, i: any) => {
                                    return (<div key={i} className="flex justify-between font-medium">
                                        <span>{item.name}</span>
                                        <span>{`${item.qty ?? 0} x ${item.price == 0 ? 'Free' : item.price}`}</span>
                                    </div>);
                                })}
                            </div>
                            : <></>
                        }

                        <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
                        <div className="flex justify-between font-bold mb-4">
                            <span>Sub Total</span>
                            <div className="items-end space-y-1">
                                <span>{currency((transaction.bookingDetail.totalPrice + transaction.bookingDetail.discount - transaction.bookingDetail.billedFeeAmount).toFixed(2))}</span>

                            </div>
                        </div>
                        <div className="flex justify-between font-bold mb-4">
                            <span>Platform fee</span>
                            <div className="items-end space-y-1">
                                <span>{currency(transaction.bookingDetail.billedFeeAmount)}</span>

                            </div>
                        </div>
                        <div className="flex justify-between font-bold mb-4">
                            <span>Discount</span>
                            <div className="items-end space-y-1">
                                <span>({currency(transaction.bookingDetail.discount)})</span>

                            </div>
                        </div>
                        <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
                        <div className="flex justify-between font-bold mb-4">
                            <span>Total</span>
                            <div className="items-end space-y-1">
                                <span>{currency(transaction.bookingDetail.totalPrice)}</span>

                            </div>
                        </div>
                        {transaction.bookingDetail.adjustmentPrice > 0 ?
                            <div className="flex flex-col space-y-2 ">
                                <div className="flex flex-row justify-between">
                                    <span className="text-sm font-semibold">{i18n.t('adjustment_price')}</span>
                                    <span className="text-primary-6000 text-sm font-bold">+{currency(transaction.bookingDetail.adjustmentPrice)}</span>
                                </div>
                                <div className="flex flex-col">
                                    <span className=" text-sm font-semibold">{i18n.t('adjustment_note')}</span>
                                    <span className="text-primary-6000 text-sm font-bold">{transaction.bookingDetail.adjustmentText}</span>
                                </div>
                                <div className="flex flex-row justify-between">
                                    <span className=" text-sm font-bold">Final Price</span>
                                    <div className="text-primary-6000 font-bold">{currency((transaction.bookingDetail.totalPrice + transaction.bookingDetail.adjustmentPrice).toFixed(2))}</div>
                                </div>
                            </div> : <></>}
                        {i18n.t('payment_confirmed') === paymentStatus(transaction.bookingDetail) ?
                            <div className="!mt-4">
                                <ButtonPrimary >
                                    Download the app to scan customer
                                </ButtonPrimary>
                            </div>

                            :
                            <div className="text-center py-4 font-semibold text-primary-6000">
                                <span>{paymentStatus(transaction.bookingDetail)}</span>
                                {user.credential.id != transaction.bookingDetail.productOwner.id && transaction.bookingDetail.stripePaymentIntent == null && transaction.bookingDetail.isDeclined == 0 && transaction.bookingDetail.cancellationStatus === null ? (
                                    <ButtonSecondary className="w-full mt-3" onClick={() => setisCancel(true)}>
                                        Cancel
                                    </ButtonSecondary>
                                ) : <></>}
                            </div>}

                        {paymentStatus(transaction.bookingDetail) === i18n.t('waiting_payment') && parseInt(user.credential.id) === transaction.bookingDetail.customer.id ?

                            transaction.bookingDetail.isManual ?
                                <div className="space-y-4">
                                    <div className="listingSection__wrap !py-2 !px-4 ">
                                        <div className="flex flex-row border-b pb-4 justify-between">
                                            <span className="text-lg font-semibold">{i18n.t('transfer_text')}</span>
                                            {/* <span className="font-semibold text-primary-6000" >{currency((transaction.bookingDetail.totalPrice + transaction.bookingDetail.adjustmentPrice).toFixed(2))}</span> */}
                                        </div>
                                        <div className="flex flex-col !mt-4 mb-2 space-y-2">
                                            <div className="flex  text-md flex-col justify-between font-semibold">
                                                <span className="text-sm text-gray-500 font-medium">Reference</span>
                                                <span>{transaction.bookingDetail.orderNumber}</span>
                                            </div>
                                            <div className="flex  text-md flex-col justify-between font-semibold">
                                                <span className="text-sm text-gray-500 font-medium">Bank</span>
                                                <span>Wise</span>
                                            </div>
                                            <div className="flex  text-md flex-col justify-between font-semibold">
                                                <span className="text-sm text-gray-500 font-medium">Account holder</span>
                                                <span>Guidesantai</span>
                                            </div>
                                            <div className="flex  text-md flex-col justify-between font-semibold">
                                                <span className="text-sm text-gray-500 font-medium">SWIFT/BIC</span>
                                                <span>TRWIBEB1XXX</span>
                                            </div>
                                            <div className="flex  text-md flex-col justify-between font-semibold">
                                                <span className="text-sm text-gray-500  font-medium">Bank Account</span>
                                                <span>2378782</span>
                                            </div>
                                            <div className="flex  text-md flex-col justify-between font-semibold">
                                                <span className="text-sm text-gray-500 font-medium">IBAN</span>
                                                <span>BE61 9672 3787 8217</span>
                                            </div>
                                            <div className="flex space-y-1 text-md flex-col justify-between font-semibold">
                                                <span className="text-sm text-gray-500 font-medium">Bank's address</span>
                                                <span>Avenue Louise 54, Room S52
                                                    Brussels
                                                    1050
                                                    Belgium</span>
                                            </div>
                                        </div>


                                    </div>
                                    <div className="!py-2">
                                        <span>
                                            {i18n.t('payment_confirmation_text')}
                                        </span>
                                    </div>

                                    <div className="space-y-2">
                                        <ButtonPrimary className="w-full" onClick={() => {
                                            window.open(`https://wa.me/41762333536?lang=en&text='Hallo konfirmasi pembayaran no ${transaction.bookingDetail.orderNumber ?? ''}'`, "_blank");
                                        }}>
                                            {i18n.t('confirm_payment')}
                                        </ButtonPrimary>
                                        {transaction.bookingDetail.stripePaymentProperty?.paymentIntent && (
                                            <ButtonSecondary className="w-full" onClick={() => {
                                                setStripeOptions({ clientSecret: transaction.bookingDetail.stripePaymentProperty.paymentIntent });
                                                setOpenStripe(true);
                                            }}>
                                                💳 {i18n.t('pay_with_credit_card')}
                                            </ButtonSecondary>
                                        )}
                                    </div>
                                </div> :

                                <div>
                                    <ButtonPrimary className="w-full" onClick={() => {
                                        if (transaction.bookingDetail.isOpenTrip) {
                                            setStripeOptions({ clientSecret: transaction.bookingDetail.stripePaymentProperty.paymentIntent })
                                            setOpenStripe(true)
                                        } else {
                                            setPaymentMethodModal(true);
                                        }
                                    }
                                    }>
                                        Pay Now
                                    </ButtonPrimary>
                                </div>

                            : <></>}

                        {paymentStatus(transaction.bookingDetail) === i18n.t('waiting_conf') && parseInt(user.credential.id) === transaction.bookingDetail.productOwner.id && (
                            showConfirmation ?
                                <div className="grid grid-cols-2 gap-1">
                                    <ButtonSecondary onClick={() => {
                                        setGoingToAccept(false);
                                        setConfirmationModal(true);
                                    }}>
                                        Decline
                                    </ButtonSecondary>
                                    <ButtonPrimary onClick={() => {
                                        setGoingToAccept(true);
                                        setConfirmationModal(true);
                                        // setStripeOptions({ clientSecret: transaction.bookingDetail.stripePaymentProperty.paymentIntent })
                                        // setOpenStripe(true)
                                    }
                                    }>
                                        Accept
                                    </ButtonPrimary>
                                </div>
                                : <div className="border px-4  py-6  rounded-md">
                                    <div className="text-center">
                                        Are you going to adjust the price according the order?
                                    </div>
                                    <div className="flex flex-row mt-4 ">
                                        <ButtonSecondary className="!py-2 flex-1 mr-4" onClick={() => {
                                            setShowConfirmation(true);
                                        }}>
                                            No
                                        </ButtonSecondary>
                                        <ButtonPrimary className="!py-2 flex-1" onClick={() => {
                                            // setGoingToAccept(true);
                                            setAdjustmentModal(true);
                                            // setStripeOptions({ clientSecret: transaction.bookingDetail.stripePaymentProperty.paymentIntent })
                                            // setOpenStripe(true)
                                        }
                                        }>
                                            Yes
                                        </ButtonPrimary>
                                    </div>
                                </div>

                        )}
                    </div>
                </div>
            </>
        )
    }
    const renderFormMobil = () => {
        return (
            <>
                {/* <Modal
                    children={() => (
                        <div className="flex flex-col w-2/3 p-8 mx-auto rounded-lg drop-shadow bg-white">
                            <span className="ml-2.5 text-neutral-900 dark:text-neutral-200 font-medium">
                                Proses ini tidak bisa dibatalkan, apakah anda yakin untuk meneruskan?
                            </span>
                            <div className="flex flex-row w-full mt-8 space-x-4">
                                <ButtonSecondary onClick={() => setConfirmationModal(false)} className="flex-1 p-2 h-min">No</ButtonSecondary>
                                <ButtonPrimary
                                    onClick={completeAction}
                                    className="flex-1 w-full h-min p-2 ">
                                    {submitting ?
                                        <Loader
                                            type="Circles"
                                            color="white"
                                            height={25}
                                            width={25}
                                        /> : 'Yes'}
                                </ButtonPrimary>
                            </div>
                        </div>
                    )}
                    isOpen={confimationModal}
                /> */}


                <div className="listingSection__wrap !pb-2">

                    <div className="flex flex-col !space-y-4">
                        <div className="flex justify-between items-center">
                            <Badge
                                name={`${transaction.bookingDetail.product.isOpenTrip ? 'Open Trip' : 'Private Trip'}`}
                                color={`${transaction.bookingDetail.product.isOpenTrip ? 'primary' : 'blue'}`} />
                            {/* <LikeSaveBtns /> */}
                        </div>

                        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold line-clamp-2">
                            {transaction.bookingDetail.product.title ?? transaction.bookingDetail.product.highlight}
                        </h2>

                        <div className="flex items-center space-x-4">
                            {/* <StartRating />
                <span>·</span> */}
                            <span>
                                <i className="las la-map-marker-alt"></i>
                                <span className="ml-1"> {transaction.bookingDetail.product.meetingAddress ? cropAddress(transaction.bookingDetail.product.meetingAddress) : ''}</span>
                            </span>
                        </div>
                    </div>
                    <div className="flex flex-col space-y-4 md:!space-y-0 md:flex-row md:items-center md:justify-between xl:justify-start md:space-x-8 xl:space-x-12 text-sm text-neutral-700 dark:text-neutral-300">
                        <div className="flex items-center space-x-3 ">
                            <i className=" las la-user text-2xl "></i>
                            <span className="">
                                {transaction?.bookingDetail?.product?.maxGuest} <span className="">{transaction?.bookingDetail?.product?.isOpenTrip ? 'Max Guests' : 'Guests included'}</span>
                            </span>
                        </div>
                        <div className="flex items-center space-x-3">
                            <i className=" las la-map-marker-alt text-2xl"></i>
                            <span className=" ">
                                {transaction?.bookingDetail?.product?.productLocation.length} <span className="">place(s) {transaction?.bookingDetail?.product?.isOpenTrip ? 'to visit' : 'recommended'}</span>
                            </span>
                        </div>
                        <div className="flex items-center space-x-3">
                            <i className=" las la-user-friends text-2xl"></i>
                            <span className="">Additional slot available</span>
                        </div>
                    </div>
                    <div className="border-b border-neutral-200 dark:border-neutral-700"></div>

                    {transaction.bookingDetail.isPaymentSuccess && transaction.bookingDetail.cancellationStatus == null ?
                        user.credential.id === transaction.bookingDetail.customer.id ?
                            <div className="flex flex-col items-center space-y-2">
                                <div className="font-medium">
                                    <span>
                                        Scan when meet the guide
                                    </span>
                                </div>
                                <div className="flex-col items-center">
                                    <QRCode value={transaction.bookingDetail.id} size={250} renderAs="svg" />
                                </div>

                                <div className="flex justify-between font-medium">
                                    <span>
                                        {transaction.bookingDetail.product.isOpenTrip ? `${moment(transaction.bookingDetail.startDate).format('MMMM Do YYYY')} -  ${moment(transaction.bookingDetail.endDate).format('MMMM Do YYYY')}` : `${moment(transaction.bookingDetail.startTripDate).format('MMMM Do YYYY')} -  ${moment(transaction.bookingDetail.endTripDate).format('MMMM Do YYYY')}`}
                                    </span>
                                </div>
                                {/* <div className="flex flex-col justify-between font-medium">
                                <span>Meeting point</span>
                                <span>{transaction.bookingDetail.product.meetingAddress}</span>
                            </div> */}
                            </div>
                            : <ButtonPrimary>
                                Download the app to scan customer
                            </ButtonPrimary>

                        : <></>}
                    <div className="flex justify-between items-center">
                        <span className="font-semibold">#{transaction.bookingDetail.orderNumber}</span>
                    </div>
                    <div>
                        <div className="flex items-center my-4">
                            <Avatar imgUrl={transaction.bookingDetail.customer.profile.avatar} hasChecked sizeClass="h-10 w-10" radius="rounded-full" />
                            <div className="flex flex-col ml-1">
                                <span className="ml-2.5 text-neutral-900 dark:text-neutral-200 font-regular text-xs">
                                    Customer
                                </span>
                                <span className="ml-2.5 text-neutral-900 dark:text-neutral-200 font-semibold text-md">
                                    {transaction.bookingDetail.customer.profile.displayName}
                                </span>
                            </div>


                        </div>
                    </div>
                    <div className="flex flex-col space-y-2">
                        <div className="flex justify-between font-medium">
                            <span>{i18n.t('small_luggage')}</span>
                            <span>{transaction.bookingDetail.smallLuggage}</span>
                        </div>
                        <div className="flex justify-between font-medium">
                            <span>{i18n.t('big_luggage')}</span>
                            <span>{transaction.bookingDetail.bigLuggage}</span>
                        </div>
                        <div className="flex justify-between font-medium">
                            <span>{i18n.t('under_twelve')}</span>
                            <span>{transaction.bookingDetail.kids.underTwelve}</span>
                        </div>
                        <div className="flex justify-between font-medium !mb-4">
                            <span>{i18n.t('under_two_year')}</span>
                            <span>{transaction.bookingDetail.kids.underTwo}</span>
                        </div>
                        <div className="flex justify-between font-medium">
                            <span>Price</span>
                            <span>{currency(transaction.bookingDetail.price)}</span>
                        </div>
                        <div className="flex justify-between font-medium">
                            {/* <span>Pax</span> */}
                            {/* <span>{transaction.bookingDetail.qty}</span> */}
                            <span>{transaction.bookingDetail.product.isOpenTrip ? 'Pax' : 'Additional slot'}</span>
                            <span>{transaction.bookingDetail.product.isOpenTrip ? transaction.bookingDetail.qty : transaction.bookingDetail.qty + ` x ` + currency(transaction.bookingDetail.additionalSlotPrice)}</span>
                        </div>

                        {transaction.bookingDetail.additionalServices.length > 0 ?
                            <div className="space-y-2 mt-2">
                                <div className="flex justify-between font-bold">
                                    <span>Additional Services</span>
                                </div>
                                {transaction.bookingDetail.additionalServices.map((item: any, i: any) => {
                                    return (<div key={i} className="flex justify-between font-medium">
                                        <span>{item.name}</span>
                                        <span>{`${item.qty ?? 0} x ${item.price == 0 ? 'Free' : item.price}`}</span>
                                    </div>);
                                })}
                            </div>
                            : <></>
                        }
                        {/* <div className="border-b border-neutral-200 dark:border-neutral-700"></div> */}
                        <div className="flex justify-between font-bold !mt-4">
                            <span>Total</span>
                            <div className="items-end space-y-1">

                                <span>{currency(transaction.bookingDetail.totalPrice)}</span>
                                {/* {transaction.bookingDetail.adjustmentPrice > 0 ?
                                    <div className="flex flex-col items-end space-y-1">
                                        <span className="text-primary-6000 text-sm font-bold">+{currency(transaction.bookingDetail.adjustmentPrice)}</span>
                                        <div className="text-primary-6000 font-bold">{currency((transaction.bookingDetail.totalPrice + transaction.bookingDetail.adjustmentPrice).toFixed(2))}</div>
                                    </div> : <></>} */}
                            </div>
                        </div>
                        {transaction.bookingDetail.adjustmentPrice > 0 ?
                            <div className="flex flex-col space-y-2 ">
                                <div className="flex flex-row justify-between">
                                    <span className="text-sm font-semibold">{i18n.t('adjustment_price')}</span>
                                    <span className="text-primary-6000 text-sm font-bold">+{currency(transaction.bookingDetail.adjustmentPrice)}</span>
                                </div>
                                <div className="flex flex-col">
                                    <span className=" text-sm font-semibold">{i18n.t('adjustment_note')}</span>
                                    <span className="text-primary-6000 text-sm font-bold">{transaction.bookingDetail.adjustmentText}</span>
                                </div>
                                <div className="flex flex-row justify-between">
                                    <span className="font-bold">Final Price</span>
                                    <div className="text-primary-6000 font-bold">{currency((transaction.bookingDetail.totalPrice + transaction.bookingDetail.adjustmentPrice).toFixed(2))}</div>
                                </div>
                            </div> : <></>}

                        <div className="!mb-4 flex flex-right justify-end !mt-4 ">
                            <span className="font-medium bg-primary-6000 bg-opacity-10 py-1 px-4 rounded-lg text-primary-6000 ">{paymentStatus(transaction.bookingDetail)}</span>
                        </div>
                        {paymentStatus(transaction.bookingDetail) === i18n.t('waiting_conf') && parseInt(user.credential.id) === transaction.bookingDetail.productOwner.id && (
                            showConfirmation ?
                                <div className="grid grid-cols-2 gap-1">
                                    <ButtonSecondary onClick={() => {
                                        setGoingToAccept(false);
                                        setConfirmationModal(true);
                                    }}>
                                        Decline
                                    </ButtonSecondary>
                                    <ButtonPrimary onClick={() => {
                                        setGoingToAccept(true);
                                        setConfirmationModal(true);
                                        // setStripeOptions({ clientSecret: transaction.bookingDetail.stripePaymentProperty.paymentIntent })
                                        // setOpenStripe(true)
                                    }
                                    }>
                                        Accept
                                    </ButtonPrimary>
                                </div>
                                : <div className="border px-4  py-6  rounded-md">
                                    <div className="text-center">
                                        Are you going to adjust the price according the order?
                                    </div>
                                    <div className="flex flex-row mt-4 ">
                                        <ButtonSecondary className="!py-2 flex-1 mr-4" onClick={() => {
                                            setShowConfirmation(true);
                                        }}>
                                            No
                                        </ButtonSecondary>
                                        <ButtonPrimary className="!py-2 flex-1" onClick={() => {
                                            // setGoingToAccept(true);
                                            setAdjustmentModal(true);
                                            // setStripeOptions({ clientSecret: transaction.bookingDetail.stripePaymentProperty.paymentIntent })
                                            // setOpenStripe(true)
                                        }
                                        }>
                                            Yes
                                        </ButtonPrimary>
                                    </div>
                                </div>

                        )}


                    </div>
                </div>

            </>
        )
    }


    return (<div className="nc-PageHome relative overflow-hidden">
        {/* <Modal
            closeButton={() => setAdjustmentModal(false)}
            children={() => (
                <div className="flex flex-col w-90 p-4 mx-auto rounded-lg drop-shadow bg-white">
                    <span className="ml-2.5 text-neutral-900 dark:text-neutral-200 text-lg font-medium">
                        Please enter your adjustment price below!
                    </span>
                    <FormItem label={t('price_adjustment')} className="mt-4 w-full justify-start items-start flex flex-col">
                        <Input onChange={(e) => setPriceAdjustment(e.target.value)} placeholder="Adjustment price" className=" w-full" />
                    </FormItem>

                    <FormItem label={t('price_adjustment_reason')} className="mt-4 w-full justify-start items-start flex flex-col">
                        <Textarea onChange={(e) => setPriceAdjustmentText(e.target.value)} placeholder="Adjustment Reason" className="w-full" />
                    </FormItem>

                    <div className="flex flex-row w-full mt-4 space-x-2 justify-end">
                        <ButtonPrimary
                            onClick={adjustPrice}
                            className="h-min p-2 ">
                            {submitting ?
                                <Loader
                                    type="Circles"
                                    color="white"
                                    height={25}
                                    width={25}
                                /> : 'Send'}
                        </ButtonPrimary>
                    </div>
                    
                </div >
            )
            }
            isOpen={adjustmentModal}
        /> */}

        <NcModal
            isOpenProp={adjustmentModal}
            renderTrigger={() => { return (<></>); }}
            contentExtraClass="lg:w-1/2"
            modalTitle={'Please enter your adjustment price below!'}
            onCloseModal={() => setAdjustmentModal(false)}
            renderContent={() => {
                return (
                    <div className="">
                        <FormItem label={t('price_adjustment')} className="mt-4 w-full justify-start items-start flex flex-col">
                            <Input onChange={(e) => setPriceAdjustment(e.target.value)} placeholder="Adjustment price" className=" w-full" />
                        </FormItem>

                        <FormItem label={t('price_adjustment_reason')} className="mt-4 w-full justify-start items-start flex flex-col">
                            <Textarea onChange={(e) => setPriceAdjustmentText(e.target.value)} placeholder="Adjustment Reason" className="w-full" />
                        </FormItem>

                        <div className="flex flex-row w-full mt-4 space-x-2 justify-end">
                            <ButtonPrimary
                                onClick={adjustPrice}
                                className="h-min p-2 ">
                                {submitting ?
                                    <Loader
                                        type="Circles"
                                        color="white"
                                        height={25}
                                        width={25}
                                    /> : 'Send'}
                            </ButtonPrimary>
                        </div>

                    </div >
                )
            }}
        />

        <NcModal
            isOpenProp={isCancel}
            renderTrigger={() => { return (<></>); }}
            renderContent={() => {
                return (
                    <div className="flex flex-col mx-auto bg-white">
                        <label>{t('cancel_not_confirmed')}</label>
                        <FormItem label={t('price_adjustment_reason')} className="mt-4 w-full justify-start items-start flex flex-col">
                            <Textarea onChange={(e) => setreasonCancel(e.target.value)} placeholder="Adjustment Reason" className="w-full" />
                        </FormItem>
                        <div className="flex flex-row w-full mt-4 space-x-2 justify-end">
                            <ButtonSecondary onClick={() => setisCancel(false)} >{t('cancel')}</ButtonSecondary>
                            <ButtonPrimary
                                onClick={() => {
                                    if (reasonCancel !== '') {
                                        setShowConfirmationCancel(true)
                                    }
                                }}
                                className="h-min p-2 ">
                                {submitting ?
                                    <Loader
                                        type="Circles"
                                        color="white"
                                        height={25}
                                        width={25}
                                    /> : 'Send'}
                            </ButtonPrimary>
                        </div>
                    </div >
                );
            }}
            contentExtraClass="lg:w-1/2"
            // onCloseModal={() => setisCancel(false)}
            hideCloseBtn={true}
            modalTitle={'Cancel Trips'}
        />

        <NcModal
            isOpenProp={showConfirmationCancel}
            renderTrigger={() => { return (<div></div>); }}
            renderContent={() => {
                return (
                    <div className="max-w-md">
                        <p className="text-center font-regular ">
                            Cancel Trips
                        </p>
                        <div className="flex justify-center space-x-5 mt-8">
                            <ButtonSecondary onClick={() => setShowConfirmationCancel(false)} >{t('no')}</ButtonSecondary>
                            <ButtonPrimary onClick={() => {
                                cancelTrip();
                            }}
                            >
                                {submitting ?
                                    <Loader
                                        type="Circles"
                                        color="white"
                                        height={25}
                                        width={25}
                                    /> : t('yes')}
                            </ButtonPrimary>
                        </div>
                    </div>
                )
            }}
            hideCloseBtn={true}
            // contentExtraClass="w-1/4"
            modalTitle={t('confirmation')}
        />
        <div className="md:py-12">
            {transaction.bookingDetail == null ?
                <DetailSkeleton />
                : <div className={`nc-ListingStayDetailPage`} data-nc-id="ListingStayDetailPage">
                    <>
                        <header className={`${openFormMobile ? 'hidden md:block' : ''}  container 2xl:px-14 rounded-md sm:rounded-xl`}>
                            <div className={`relative hidden md:block md:grid md:gap-2  ${transaction.bookingDetail.product.file.length > 1 ? 'md:grid-cols-3 xl:grid-cols-4 ' : `md:grid-cols-${transaction.bookingDetail.product.file.length}`} `}>
                                <div className="col-span-2 row-span-3 sm:row-span-2 relative rounded-md sm:rounded-xl overflow-hidden cursor-pointer"
                                    onClick={() => handleOpenModal(0)}
                                >
                                    <NcImage
                                        containerClassName={`${transaction.bookingDetail.product.file.length > 1 ? 'absolute inset-0' : ' h-96'}`}
                                        className="object-cover w-full h-full rounded-md sm:rounded-xl"
                                        src={getUrl(transaction.bookingDetail.product.file[0].urls[4])}
                                        prevImageHorizontal
                                    />
                                    <div className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity"></div>
                                </div>
                                {transaction.bookingDetail.product.file.filter((_: any, i: any) => i >= 1 && i < 5).map((item: any, index: any) => (
                                    <div key={index} className={`relative rounded-md sm:rounded-xl overflow-hidden ${index >= 3 ? "hidden sm:block" : ""}`}>
                                        <NcImage
                                            containerClassName="aspect-w-4 aspect-h-3 sm:aspect-w-6 sm:aspect-h-5"
                                            className="object-cover w-full h-full rounded-md sm:rounded-xl "
                                            src={getUrl(item.urls[4])}
                                            prevImageHorizontal
                                        />
                                        <div
                                            className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity cursor-pointer"
                                            onClick={() => handleOpenModal(index + 1)}
                                        />
                                    </div>
                                ))}

                                < div
                                    className="absolute hidden md:flex md:items-center md:justify-center left-3 bottom-3 px-4 py-2 rounded-xl bg-neutral-100 text-neutral-500 cursor-pointer hover:bg-neutral-200 z-10"
                                    onClick={() => handleOpenModal(0)}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-5 w-5"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={1.5}
                                            d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
                                        />
                                    </svg>
                                    <span className="ml-2 text-neutral-800 text-sm font-medium">
                                        Show all photos
                                    </span>
                                </div>
                            </div>
                            <div className={` flex flex-col md:hidden`}>
                                <div
                                    className="relative rounded-md overflow-hidden cursor-pointer h-64 w-full"
                                    onClick={() => handleOpenModal(0)}
                                >
                                    <NcImage
                                        containerClassName={`${transaction.bookingDetail.product.file.length > 1 ? 'absolute inset-0' : ' h-96'}`}
                                        className="object-cover w-full h-full rounded-md sm:rounded-xl"
                                        src={getUrl(transaction.bookingDetail.product.file[0].urls[4])}
                                        prevImageHorizontal
                                    />
                                </div>
                                <div className="grid grid-cols-4 gap-2 mt-2">
                                    {transaction.bookingDetail.product.file.filter((_: any, i: any) => i >= 1 && i < 5).map((item: any, index: any) => (
                                        <div key={index} className={`relative rounded-md overflow-hidden `}>
                                            <NcImage
                                                containerClassName="aspect-w-4 aspect-h-3 sm:aspect-w-6 sm:aspect-h-5"
                                                className="object-cover w-full h-full rounded-md sm:rounded-xl "
                                                src={getUrl(item.urls[4])}
                                                prevImageHorizontal
                                            />
                                            {transaction.bookingDetail.product.file.length > 5 && index === 3 ?
                                                <div
                                                    className="absolute inset-0 bg-black bg-opacity-50 transition-opacity cursor-pointer justify-center item-center w-full flex flex-col"
                                                    onClick={() => handleOpenModal(0)}
                                                >
                                                    <p className="text-white text-xs text-center">
                                                        Show all
                                                    </p>
                                                </div>
                                                :
                                                <div
                                                    className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity cursor-pointer"
                                                    onClick={() => handleOpenModal(index + 1)}
                                                />
                                            }
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </header>
                        <ModalPhotos
                            imgs={transaction.bookingDetail.product.file}
                            isOpen={isOpen}
                            onClose={handleCloseModal}
                            initFocus={openFocusIndex}
                        />
                    </>
                    <main className="container flex ">

                        <div className={`${openFormMobile ? 'hidden md:block' : ''} w-full lg:w-3/5 xl:w-2/3 space-y-8 lg:space-y-10 lg:pr-10`}>
                            <DetailRenderSection1 trip={transaction.bookingDetail.product} reserveTitle="Lihat Harga" reserve={() => setOpenFormMobile(true)} />

                            <RenderBookingInfo booking={transaction.bookingDetail} />
                            <RenderThingsToKnow trip={transaction.bookingDetail.product} />
                        </div>
                        <div className={`hidden lg:block  flex-grow `}>
                            <div className="sticky top-24">{renderSidebar()}</div>
                        </div>
                        <div className={`${openFormMobile ? 'block md:hidden' : 'hidden'}  w-full`}>
                            {renderFormMobil()}
                            <div className="mt-4">
                                <RenderBookingInfo booking={transaction.bookingDetail} />
                            </div>
                        </div>
                    </main>

                    {/* <Modal
                        closeButton={() => setPaymentMethodModal(false)}
                        children={() => (
                            <div className="flex flex-col w-2/3 p-4 mx-auto rounded-lg drop-shadow bg-white">
                                <span className=" text-neutral-900 dark:text-neutral-200 font-semibold">
                                    Metode Pembayaran
                                </span>
                                <span className=" text-sm text-neutral-900 dark:text-neutral-200 font-regular">
                                    Manual transfer akan memerlukan konfirmasi kamu ke team kami melalui whatsapp
                                </span>
                                <div className="flex flex-col w-full mt-8 space-4">
                                    <ButtonSecondary onClick={goWithTransfer} className="w-full p-2 h-min">
                                        {submitting ?
                                            <Loader
                                                type="Circles"
                                                color="white"
                                                height={25}
                                                width={25}
                                            /> : 'Manual Transfer'}
                                    </ButtonSecondary>
                                    <ButtonPrimary onClick={() => {
                                        setPaymentMethodModal(false)
                                        setStripeOptions({ clientSecret: transaction.bookingDetail.stripePaymentProperty.paymentIntent })
                                        setOpenStripe(true)
                                    }} className=" w-full h-min p-2 mt-4 ">
                                        Kartu kredit
                                    </ButtonPrimary>
                                </div>
                            </div>
                        )}
                        isOpen={paymentMethodModal}
                    /> */}

                    <NcModal
                        isOpenProp={paymentMethodModal}
                        renderTrigger={() => { return (<></>); }}
                        renderContent={() => {
                            return (
                                <div className="">

                                    <div className="flex flex-col w-full mt-8 space-4">
                                        <div>
                                            <ButtonSecondary onClick={goWithTransfer} className="w-full p-2 h-min">
                                                {submitting ?
                                                    <Loader
                                                        type="Circles"
                                                        color="white"
                                                        height={25}
                                                        width={25}
                                                    /> : 'Manual Transfer'}
                                            </ButtonSecondary>
                                            <span className=" text-xs text-neutral-900 dark:text-neutral-200 font-regular">
                                                {t("manual_transfer")}
                                            </span>
                                        </div>
                                        <ButtonPrimary onClick={() => {
                                            setPaymentMethodModal(false);
                                            setStripeOptions({ clientSecret: transaction.bookingDetail.stripePaymentProperty.paymentIntent })
                                            setTimeout(() => {
                                                setOpenStripe(true);
                                            }, 500);
                                        }} className=" w-full h-min p-2 mt-4 ">
                                            {t('credit_card')}
                                        </ButtonPrimary>
                                    </div>
                                </div>
                            );
                        }}
                        onCloseModal={() => setPaymentMethodModal(false)}
                        modalTitle={t("payment_method")}
                    />

                    {openFormMobile ?
                        <>
                            {paymentStatus(transaction.bookingDetail) === i18n.t('waiting_payment') && parseInt(user.credential.id) === transaction.bookingDetail.customer.id ?
                                transaction.bookingDetail.isManual ?
                                    <div className="space-y-4 px-4 md:hidden">
                                        <div className="listingSection__wrap py-4">
                                            <h2 className="text-sm font-semibold">{i18n.t('transfer_text')}</h2>
                                            <div className="flex flex-col !mt-4 mb-2 space-y-2">
                                                <div className="text-md flex flex-col font-semibold">
                                                    <span className="text-sm text-gray-500 font-medium">Reference</span>
                                                    <span>{transaction.bookingDetail.orderNumber}</span>
                                                </div>
                                                <div className="flex  text-sm flex-col justify-between font-semibold">
                                                    <span className="text-xs text-gray-500 font-medium">Bank</span>
                                                    <span>Wise</span>
                                                </div>
                                                <div className="flex  text-sm flex-col justify-between font-semibold">
                                                    <span className="text-xs text-gray-500 font-medium">Account holder</span>
                                                    <span>Guidesantai</span>
                                                </div>
                                                <div className="flex  text-sm flex-col justify-between font-semibold">
                                                    <span className="text-xs text-gray-500 font-medium">SWIFT/BIC</span>
                                                    <span>TRWIBEB1XXX</span>
                                                </div>
                                                <div className="flex  text-sm flex-col justify-between font-semibold">
                                                    <span className="text-xs text-gray-500  font-medium">Bank Account</span>
                                                    <span>2378782</span>
                                                </div>
                                                <div className="flex  text-sm flex-col justify-between font-semibold">
                                                    <span className="text-xs text-gray-500 font-medium">IBAN</span>
                                                    <span>BE61 9672 3787 8217</span>
                                                </div>
                                                <div className="flex space-y-1 text-sm flex-col justify-between font-semibold">
                                                    <span className="text-xs text-gray-500 font-medium">Bank's address</span>
                                                    <span>Avenue Louise 54, Room S52
                                                        Brussels
                                                        1050
                                                        Belgium</span>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="!py-2">
                                            <span>
                                                {i18n.t('payment_confirmation_text')}
                                            </span>
                                        </div>
                                        <div className="block md:hidden fixed bottom-0 left-0 z-10 w-full flex flex-col p-2 bg-white border-t space-y-2 shadow-lg">
                                            <ButtonPrimary className="w-full" onClick={() => {
                                                window.open(`https://wa.me/41762333536?lang=en&text='Hallo konfirmasi pembayaran no ${transaction.bookingDetail.orderNumber ?? ''}'`, "_blank");
                                            }}>
                                                {i18n.t('confirm_payment')}
                                            </ButtonPrimary>
                                            {transaction.bookingDetail.stripePaymentProperty?.paymentIntent && (
                                                <ButtonSecondary className="w-full" onClick={() => {
                                                    setStripeOptions({ clientSecret: transaction.bookingDetail.stripePaymentProperty.paymentIntent });
                                                    setOpenStripe(true);
                                                }}>
                                                    💳 {i18n.t('pay_with_credit_card')}
                                                </ButtonSecondary>
                                            )}
                                        </div>
                                    </div> :
                                    <div className="fixed bottom-0 z-10 w-full block md:hidden">
                                        <ButtonPrimary className="w-full !rounded-none" onClick={() => {
                                            if (transaction.bookingDetail.isOpenTrip) {
                                                setStripeOptions({ clientSecret: transaction.bookingDetail.stripePaymentProperty.paymentIntent })
                                                setOpenStripe(true)
                                            } else {
                                                setPaymentMethodModal(true);
                                            }
                                        }
                                        }>
                                            Pay Now
                                        </ButtonPrimary>
                                    </div>
                                : user.credential.id != transaction.bookingDetail.productOwner.id && transaction.bookingDetail.stripePaymentIntent == null && transaction.bookingDetail.isDeclined == 0 && transaction.bookingDetail.cancellationStatus === null ? (
                                    <div className="fixed bottom-0 z-10 w-full block md:hidden">
                                        <ButtonPrimary className="w-full !rounded-none" onClick={() => setisCancel(true)}>
                                            Cancel
                                        </ButtonPrimary>
                                    </div>
                                ) : <></>}

                            {/* {paymentStatus(transaction.bookingDetail) === i18n.t('waiting_conf') && parseInt(user.credential.id) === transaction.bookingDetail.productOwner.id && (
                                showConfirmation ?
                                    <div className="grid grid-cols-2 gap-1">
                                        <ButtonSecondary className="my-4" onClick={() => {
                                            setGoingToAccept(false);
                                            setConfirmationModal(true);
                                        }}>
                                            Decline
                                        </ButtonSecondary>
                                        <ButtonPrimary className="my-4" onClick={() => {
                                            setGoingToAccept(true);
                                            setConfirmationModal(true);
                                            // setStripeOptions({ clientSecret: transaction.bookingDetail.stripePaymentProperty.paymentIntent })
                                            // setOpenStripe(true)
                                        }
                                        }>
                                            Accept
                                        </ButtonPrimary>
                                    </div>
                                    : <></>

                            )} */}
                        </>
                        : <div></div>}
                </div>
            }
        </div>

    </div >);
}

export default OrderDetail;


export const RenderBookingInfo: FC<{ booking: any }> = ({ booking }) => {
    const [center, setcenter] = useState({
        lat: parseFloat(booking.product.meetingLat),
        lng: parseFloat(booking.product.meetingLng),
    })


    return (
        <div className="listingSection__wrap">
            {/* <ToastContainer position="bottom-right" /> */}

            <h2 className="text-2xl font-semibold">Information</h2>
            <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
            <div className="text-neutral-6000 dark:text-neutral-300 space-y-2">
                {/* {booking.isPaymentSuccess && booking.cancellationStatus == null ? */}
                <div className="flex flex-col space-y-2 mb-2">
                    <div className="flex  text-md flex-col justify-between font-medium">
                        <span className="text-sm font-bold">Trip Date</span>
                        <span className="font-semibold text-neutral-500">{booking.product.isOpenTrip ? `${moment(booking.startDate).format('MMMM Do YYYY')} -  ${moment(booking.endDate).format('MMMM Do YYYY')}` : `${moment(booking.startTripDate).format('MMMM Do YYYY')} -  ${moment(booking.endTripDate).format('MMMM Do YYYY')}`}
                        </span>
                    </div>
                    <div className="flex  text-md flex-col justify-between font-medium">
                        <span className="text-sm font-bold">Additional Contact</span>
                        <span className="font-semibold text-neutral-500">{booking.product.additionalContact}</span>
                    </div>
                    <div className="flex  text-md flex-col justify-between font-medium">
                        <span className="text-sm font-bold">Meeting point</span>
                        <span className="font-semibold text-neutral-500">{booking.product.meetingAddress}</span>
                        <div className="" style={{ height: '30vh', width: '100%' }}>
                            <GoogleMapReact
                                defaultZoom={15}
                                center={center}
                                defaultCenter={center}
                            // onDrag={((map) => {
                            //     setLat(map.center.lat());
                            //     setLng(map.center.lng());
                            // })}

                            // // onDragEnd={(map) => {
                            //     meetingAddressUpdate(map.center.lat(), map.center.lng());
                            // }}

                            >
                                <LocationMarker lat={center['lat']} lng={center['lng']} />
                            </GoogleMapReact>
                        </div>
                    </div>

                </div>

                {/* : <></>} */}
                <div className="flex  text-md flex-col justify-between font-medium">
                    <span className="text-sm font-bold">Highlight</span>
                    <span className="font-semibold text-neutral-500">{booking.product.highlight}</span>
                </div>
                <div className="flex  text-md flex-col justify-between font-medium">
                    <span className="text-sm font-bold">Description</span>
                    <span className="font-semibold text-neutral-500">{booking.product.description}</span>
                </div>
            </div>
        </div>
    );
}